import { DialogButtonBar } from '../Dialog/DialogButtonBar.js';
export const ModalButtonBar = Object.assign({}, DialogButtonBar);
